if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {

      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-collapsible]'));
        this.colorScheme = this.dataset.colorScheme;

        this.items.forEach((item) => {
          const trigger = item.querySelector('[data-collapsible-trigger]');
          const content = item.querySelector('[data-collapsible-content]');

          trigger.style.cursor = 'pointer';
          trigger.style.userSelect = 'none';
          trigger.setAttribute('tabindex', '0');
          trigger.setAttribute('role', 'button');

          const isOpen = item.dataset.open === 'true';
          isOpen ? this.openItem(item, content) : this.closeItem(item, content);

          trigger.addEventListener('click', () => this.toggleItem(item));
          trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleItem(item);
            }
          });
        });
      }

      toggleItem(item) {
        const content = item.querySelector('[data-collapsible-content]');
        const expanded = item.getAttribute('aria-expanded') === 'true';

        expanded ? this.closeItem(item, content) : this.openItem(item, content);
      }

      // 🚫 Nessuna animazione → apertura immediata
      openItem(item, content) {
        item.setAttribute('aria-expanded', 'true');
        item.dataset.open = "true";

        content.style.display = 'block';
        content.style.maxHeight = 'none';
        content.style.opacity = '1';
        content.setAttribute('aria-hidden', 'false');

        const trigger = item.querySelector('[data-collapsible-trigger]');
        trigger.setAttribute('aria-expanded', 'true');

        const parent = item.closest('.accordion-item');
        parent?.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      // 🚫 Nessuna animazione → chiusura immediata
      closeItem(item, content) {
        item.setAttribute('aria-expanded', 'false');
        item.dataset.open = "false";

        content.style.display = 'none';
        content.style.maxHeight = 'none';
        content.style.opacity = '1';
        content.setAttribute('aria-hidden', 'true');

        const trigger = item.querySelector('[data-collapsible-trigger]');
        trigger.setAttribute('aria-expanded', 'false');

        const parent = item.closest('.accordion-item');
        parent?.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
